module.exports = __webpack_public_path__ + "img/inspiration_05.4b91b0d.jpg";